import React, { Component } from 'react'
import {Button, Col, Container, FormGroup, Input, Label, Row} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../../principal/containers/DataWrapper";
import CabotagemStore from "../stores/CabotagemStore";
import FiltrosCabotagem from "../components/FIltrosCabotagem";
import {TabelaCabotagem} from "../components/TabelaCabotagem";
import {CabotagemCadastrar} from "../components/CabotagemCadastrar";
import {TabelaCabotagemNovas} from "../components/TabelaCabotagemNovas";
import CabotagemService from "../../../../services/CabotagemService";
import {CabotagemImportaXLS} from "../components/CabotagemImportaXLS";
import {IconeCarregar} from "../../../comum/components/Icones";
import ModalForm from "../../../comum/components/ModalForm";
import ModalAviso from "../../../comum/components/ModalAviso";
import Footer from "../../../comum/components/Footer";
import FooterContent from "../../../comum/components/FooterContent";
import FooterOptions from "../../../comum/components/FooterOptions";
import IconButton from "../../../comum/components/IconButton";
import {makePDF} from "../../../../utils/formatar";
import ExportarExcelCabotagem from "../components/ExportarExcelCabotagem";
import _ from "lodash"

@inject("store")
@DataWrapper
@observer
export class Cabotagem extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.service = new CabotagemService();
        this.controller = new CabotagemStore(this.service);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Liberações de Cabotagem");       
        this.controller.carregarDados();
        
        let voltarParam = _.get(this.props.location.state,`voltar`);
        this.props.store.appStore.showVoltarTopBar(voltarParam ? true : false, voltarParam ? voltarParam : '/');
    };

    componentDidUpdate() {
        this.tituloPaginaStore.setTitulo(this.controller.novasCabotagens.length > 0 ? "Novas liberações" : "Liberações de Cabotagem");
    };

    cabotagemCadastrar = () => {
        if (this.controller.inserindo)
            return <CabotagemCadastrar controller={ this.controller } />
    };

    cabotagemEditar = () => {
        if (this.controller.posEditando > -1 && this.controller.estadoEditando)
            return <CabotagemCadastrar controller={ this.controller } editando={ this.controller.estadoEditando } />
    };

    modalCarregarXML() {
        if (this.controller.inserindoXml)
            return <CabotagemImportaXLS controller={ this.controller } service={this.service} />
    }

    modalConfirmaInativar = () => {
        if (this.controller.modalInativar)
            return <ModalForm labelCancelar="NÃO"
                              labelConfirmar="SIM"
                              salvando={this.controller.inativandoLoading}
                              onClickCancelar={ () => this.controller.cancelaInativar() }
                              onClickSalvar={ () => this.controller.confirmarInativar() }>
                { this.controller.selecionados.length === 1
                    ? <h2>Deseja inativar o CTe selecionado?</h2>
                    : <h2>Deseja inativar os CTes selecionados?</h2>
                }
            </ModalForm>
    };

    aviso = () => {
        if (this.controller.listaMensagens)
            return <ModalAviso onClickFechar={ () => this.controller.listaMensagens = false }>
                { this.controller.listaMensagens.map((msg, x) =>
                    <h2 key={x}>{ msg }</h2>
                )
            }
        </ModalAviso>
    };

    inserindoNovas = () => {
        return this.controller.novasCabotagens.length > 0;
    };

    render() {
        let pdfData = this.controller.colunasExportacao
        
        const msgSelecionadas = this.controller.selecionados.length === 1 ? "Liberação selecionada" : "Liberações selecionadas";
        return (
            <div className="form-wrapper">
                { this.aviso() }
                { this.cabotagemCadastrar() }
                { this.modalCarregarXML() }
                { this.cabotagemEditar() }
                { this.modalConfirmaInativar() }
                <Container className="liberacao-cabotagem tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12} >
                            <Button disabled={!this.controller.naviosFiltros} onClick={ () => this.controller.inserindo = true } className="btn-com-bordas-primary">Nova Liberação</Button>
                            <Button disabled={!this.controller.naviosFiltros} onClick={ () => this.controller.inserindoXml = true } className="btn-com-bordas-cinza">Importar Planilha</Button>
                        </Col>
                    </Row>
                    <FiltrosCabotagem controller={this.controller} />
                    
                    { this.inserindoNovas()
                        ? <TabelaCabotagemNovas controller={this.controller} />
                        : <TabelaCabotagem controller={this.controller} />
                    }
                </Container>

                { !this.inserindoNovas()
                    && <Footer>
                        <FooterContent>
                            <div className="justify-content-between">
                            { this.controller.selecionados.length > 0
                                ? <div><b>{this.controller.selecionados.length}</b> {msgSelecionadas}</div>
                                : <div>
                                        <b>{this.controller.itens.length}</b> Registros no Total
                                        { this.controller.estadoFiltros
                                            && <React.Fragment>
                                                - <a onClick={ () => this.controller.reListar() } >Atualizar Lista</a>
                                            </React.Fragment>
                                        }
                                    </div>
                                }
                            </div>
                        </FooterContent>
                        <FooterOptions>
                            <div>
                                <IconButton
                                    icon="file-pdf"
                                    text="Baixar PDF"
                                    size="md"
                                    disabled={this.controller.cabotagemLista.length===0}
                                    onClick={
                                        () => makePDF(
                                            this.controller.cabotagemLista,
                                            pdfData.map(elem => elem.dataField),
                                            pdfData.map(elem => elem.text),
                                            [],
                                            true,
                                            false,
                                            {qtdColFixo: "A2", nomeDoArquivo: "LiberaçãoDeCabotagem.pdf"}
                                        )
                                    }
                                />
                            </div>
                            <div>
                                <ExportarExcelCabotagem controller = {this.controller} />
                            </div>
                        </FooterOptions>
                        <FooterContent className="right-pos">
                            <div>
                                { !this.controller.salvando
                                    ? <Button disabled={ this.controller.selecionados.length===0 } className="btn-primary" onClick={ () => this.controller.abrirModalInativar() }>INATIVAR LIBERAÇÃO</Button>
                                    : <IconeCarregar tamanho="2x" cor="#001C43" />
                                }
                            </div>
                        </FooterContent>
                    </Footer>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/telas/Cabotagem.js